import React from "react";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export const TablePage = () => {
  // console.log("tictka", Data);

  const { searchedTickets, isLoading, error } = useSelector(
    (state) => state.tickets
  );

  if (isLoading) {
    return <h1>Loading...</h1>;
  }
  if (error) {
    return <h1>{error}</h1>;
  }

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>id</th>
          <th>Subject</th>
          <th>Status</th>
          <th>Added At</th>
        </tr>
      </thead>
      <tbody>
        {searchedTickets.length ? (
          searchedTickets.map((row) => (
            <tr row={row._id}>
              <Link to={`/ticketpage/${row._id}`}>
                <td>{row._id}</td>
              </Link>
              <td>{row.subject}</td>
              {row.status === "Closed" ? (
                <td style={{ color: "red" }}>{row.status} </td>
              ) : (
                <td style={{ color: "green" }}>{row.status}</td>
              )}
              <td>{row.openAt}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td>No Tickets</td>
          </tr>
        )}
        {/* {Data.map((row) => (
          <tr>
            <td>{row.id}</td>
            <td>{row.status}</td>
            <td>{row.addedAt}</td>
          </tr>
        ))} */}
      </tbody>
    </Table>
  );
};
